__turbopack_context__.v({
  "btn-glow-rotate": "button-module__HjQxJG__btn-glow-rotate",
  "button": "button-module__HjQxJG__button",
  "buttonIconCenter": "button-module__HjQxJG__buttonIconCenter",
  "buttonIconEnd": "button-module__HjQxJG__buttonIconEnd",
  "buttonIconStart": "button-module__HjQxJG__buttonIconStart",
  "buttonTextCenter": "button-module__HjQxJG__buttonTextCenter",
});
